import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ArrowLeftCircle } from "react-feather";

import { useTeamContext } from "../contexts/TeamContext";
import Page from "./Page";
import Button from "../components/UI/Button/Button";
import PropertyPanel from "../components/Property/PropertyPanel";

import "./Property.scss";

export default function PropertyPage() {
	const { id } = useParams();
	const team = useTeamContext();
	const navigate = useNavigate();

	//getting the previous page from url - couldn't get anything without URLSearchParams working bc I think react-router-dom took away the function I wanted
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const from = queryParams.has("from") ? queryParams.get("from") : "epc-data";

	if (isNaN(id)) {
		throw new Error("Invalid property ID");
	}

	return (
		<Page className="property">
			<Button variant="outlined-borderless go-back" onClick={() => navigate("/" + from)}>
				<ArrowLeftCircle color="white" fill="black" size={20} />
				Go Back
			</Button>
			<PropertyPanel teamId={team.id} propertyId={Number(id)} />
		</Page>
	);
}
